import React from 'react';

// Renders WebP with automatic fallback. Accepts absolute or relative paths.
// If src does not end with .webp, falls back to a plain <img> tag.
const Picture = ({
  src,
  alt = '',
  className = '',
  imgClassName,
  pictureClassName = '',
  style,
  fallbackExt = 'jpg',
  pictureProps = {},
  ...rest
}) => {
  const appliedImgClassName = imgClassName ?? className;

  if (!src || !/\.webp($|\?)/i.test(src)) {
    return <img src={src} alt={alt} className={appliedImgClassName} style={style} {...rest} />;
  }

  const [base, ...queryParts] = src.split('?');
  const fallbackBase = base.replace(/\.webp$/i, `.${fallbackExt}`);
  const query = queryParts.length ? `?${queryParts.join('?')}` : '';
  const fallbackSrc = `${fallbackBase}${query}`;

  return (
    <picture className={pictureClassName} {...pictureProps}>
      <source srcSet={src} type="image/webp" />
      <img src={fallbackSrc} alt={alt} className={appliedImgClassName} style={style} {...rest} />
    </picture>
  );
};

export default Picture;

